define.alias("shared/components/shared/loading-spinner", "media/components/shared/loading-spinner");